import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "icon"]

  toggle() {
    const expanded = this.contentTarget.classList.toggle("hidden")
    this.element.querySelector("button").setAttribute("aria-expanded", !expanded)
    this.iconTarget.style.transform = expanded ? "" : "rotate(180deg)"
  }
}
